<!--
  - 导航快速跳转组件
-->

<template>
  <div class="bl-navbar">
    <div class="bl-content">
      <div v-for="(item, index) in items" class="bl-item" @click="tag_jump(item.anchor)">
        <div class="bl-icon">
          <svg width="35%" :class="item.class" aria-hidden="true">
            <use :xlink:href="item.icon"></use>
          </svg>
        </div>
        <div class="bl-desc">
          <h2>{{item.title}}</h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'navbar',
    data(){
      return {
        items: [
          {
            title: '开发工具',
            icon: '#icon-icon-test',
            class: 'icon icon-runcode',
            anchor: '#tag-runcode'
          },
          {
            title: '管理工具',
            icon: '#icon-fuwuqi1',
            class: 'icon icon-manager',
            anchor: '#tag-system'
          },
          {
            title: '前端工具',
            icon: '#icon-js',
            class: 'icon icon-front',
            anchor: '#tag-frontend'
          },
          {
            title: '其他工具',
            icon: '#icon-tool-on',
            class: 'icon icon-other',
            anchor: '#tag-other'
          }
        ]
      }
    },
    methods: {
      tag_jump(tag){
          let hs_hight = $(tag).offset().top;
          $("html, body").animate({
            scrollTop: hs_hight + "px"
          }, 400);
      }
    }
  }
</script>

<style scoped lang="less">
  @icon-front-color: #E671B8;
  @icon-other-color: #00529C;

  .bl-navbar {
    display: flex;
    height: 80px;

    div {
      display: flex;
      flex: 1;
      flex-direction: column;
      justify-content: center;
    }
    div.bl-content {
      display: flex;
      flex-direction: row;
      flex: 5;
      //item 样式
      .bl-item {
        display: flex;
        flex-direction: row;
        flex: 1;
        border-left: 1px solid #ddd;
        margin-top: 5px;
        cursor: pointer;
        transition: box-shadow 0.3s;
        //navbar 左侧图标
        .bl-icon {
          flex: 1;
          flex-direction: row;
          justify-content: flex-end;
          padding-right: 10px;

          .icon-front {
            color: @icon-front-color;
          }
          .icon-other {
            color: @icon-other-color;
          }
        }
        //navbar 右侧描述
        .bl-desc {
          flex: 1;
          flex-direction: column;
          justify-content: center;
        }
      }
      //去掉第一个左边框
      .bl-item:first-child {
        border-left: none;
      }
      //hover样式
      .bl-item:hover {
        box-shadow: 0 0 15px #ccc;
      }
    }
  }
</style>

